import React, { useState, useRef, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { useMutation } from 'react-query';
import { useQuery } from 'react-query';
import { CredusButton, CredusText, CredusSelect, OptionType } from 'ui';

import { saveAs } from '../../../../../utils/helpers';
import testApi, { Category, Period } from '../../../../../api/test';
import { objectToFormData } from '../../../../../utils/helpers';
import PageLoader from '../../../PageLoader';
import { CandidateContext } from '../../../../../contexts/CandidateContext';
import ComponentLoader from '../../../ComponentLoader';

interface ImportCandidatesProps {
  showImportCandidate: boolean;
  setShowImportCandidate: React.Dispatch<React.SetStateAction<boolean>>;
  setCandidateReUpload: React.Dispatch<React.SetStateAction<boolean>>;
}
interface ExamCategoryProps {
  setStep: React.Dispatch<React.SetStateAction<number>>;
}
interface QuestionTemplateProps {
  setShowImportCandidate: React.Dispatch<React.SetStateAction<boolean>>;
  setCandidateReUpload: React.Dispatch<React.SetStateAction<boolean>>;
}

const ExamCategory = ({ setStep }: ExamCategoryProps) => {
  const [CategoryId, setcategoryId] = useState(0);
  const [PeriodId, setPeriodId] = useState(0);
  const { setCandidateData, setCandidateCategory } =
    useContext(CandidateContext);
  const { data, isLoading: categoryLoading } = useQuery(
    ['testCategoriesForCandidateUpload', 1],
    () => testApi.getTestCategories(1)
  );
  const { data: periodData, isLoading: periodLoading } = useQuery(
    ['testPeriod', 1],
    () => testApi.getTestPeriod(1)
  );

  const categories = data?.data?.map((el: Category) => ({
    optionName: el.name,
    optionValue: el.name,
    optionId: el.id,
  }));
  const period = periodData?.data?.map((el: Period) => ({
    optionName: el.period,
    optionValue: el.period,
    optionId: el.periodId,
  }));

  const handleClick = () => {
    setCandidateData((prev) => ({
      ...prev,
      PeriodId,
      CategoryId,
      InstitutionId: 1,
    }));
    setStep((prev) => prev + 1);
  };

  const handleCategory = (id: number, category: string) => {
    setcategoryId(id);
    setCandidateCategory((prev) => ({ ...prev, category }));
  };
  const handlePeriod = (id: number, period: string) => {
    setPeriodId(id);
    setCandidateCategory((prev) => ({ ...prev, period }));
  };
  return (
    <Form>
      {categoryLoading || periodLoading ? (
        <ComponentLoader />
      ) : (
        <>
          <CredusSelect
            options={categories}
            placeholder="e.g  Foundational"
            label="Exam Category"
            onChange={(value) =>
              handleCategory(
                categories?.filter(
                  (el: OptionType) => el.optionValue == value
                )[0]?.optionId,
                categories?.filter(
                  (el: OptionType) => el.optionValue == value
                )[0]?.optionValue
              )
            }
          />
          <CredusSelect
            options={period}
            placeholder="June 2023 Diet 1"
            label="Period"
            onChange={(value) =>
              handlePeriod(
                period?.filter((el: OptionType) => el.optionValue == value)[0]
                  ?.optionId,
                period?.filter((el: OptionType) => el.optionValue == value)[0]
                  ?.optionValue
              )
            }
          />
          {/* <CredusInput label="code" placeholder="e.g  FD/001" /> */}
          <FooterDiv>
            <CredusButton variant="secondary">Cancel</CredusButton>
            <CredusButton onClick={handleClick}>Save and Continue</CredusButton>
          </FooterDiv>
        </>
      )}
    </Form>
  );
};
const QuestionTemplate = ({
  setCandidateReUpload,
  setShowImportCandidate,
}: QuestionTemplateProps) => {
  const [loading, setLoading] = useState(false);
  const [File, setFile] = useState<File>();
  const { setCandidateData } = useContext(CandidateContext);
  const hiddenFileInput = useRef<HTMLInputElement>(null);

  const { mutate } = useMutation(testApi.uploadCandidateFile, {
    onMutate: () => setLoading(true),
    onSuccess: (data) => {
      setCandidateData((prev) => ({ ...prev, Candidates: data?.data }));
      setTimeout(() => {
        setLoading(false);
        setShowImportCandidate(false);
        setCandidateReUpload(true);
      }, 2000);
    },
    onError: (error) => {
      setLoading(false);
      throw error;
    },
  });

  useEffect(() => {
    if (File) {
      const formData = objectToFormData({
        File,
        InstitutionId: 1,
      });
      mutate(formData);
    }
  }, [File]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = event.target.files?.[0];
    setFile(fileUploaded);
  };

  const handleFileUpload = () => {
    hiddenFileInput?.current?.click();
  };

  const handleDownload = () => {
    saveAs(
      `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`,
      'Credus Candidate Format.xlsx'
    );
  };

  return (
    <TemplateDiv>
      {loading && <PageLoader loaderText="Uploading candidates..." />}
      <CredusText size="md">
        Candidates are imported by downloading and completing the excel template{' '}
      </CredusText>

      <div>
        <CredusButton variant="secondary" size="small" onClick={handleDownload}>
          Download template
        </CredusButton>
      </div>

      <CredusText size="md">
        If you’ve already completed the template, use the ‘select file’ button
        to import your question
      </CredusText>
      <FooterDiv>
        <CredusButton variant="secondary">Cancel</CredusButton>
        <CredusButton onClick={handleFileUpload}>Select file</CredusButton>
        <input
          type="file"
          ref={hiddenFileInput}
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
      </FooterDiv>
    </TemplateDiv>
  );
};
const ImportCandidatesModal = ({
  showImportCandidate,
  setShowImportCandidate,
  setCandidateReUpload,
}: ImportCandidatesProps) => {
  const [step, setStep] = useState(0);
  return (
    <Modal
      title={
        <CredusText size="md" weight="medium">
          Import Candidates
        </CredusText>
      }
      open={showImportCandidate}
      footer=""
      onCancel={() => setShowImportCandidate(false)}
    >
      <>
        {
          [
            <ExamCategory setStep={setStep} />,
            <QuestionTemplate
              setCandidateReUpload={setCandidateReUpload}
              setShowImportCandidate={setShowImportCandidate}
            />,
          ][step]
        }
      </>
    </Modal>
  );
};

export default ImportCandidatesModal;

const FooterDiv = styled.div`
  display: flex;
  padding-top: 2rem;
  width: 100%;
  justify-content: flex-end;
  gap: 1rem;
`;

const Form = styled.form`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const TemplateDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  padding-top: 2.5rem;
  gap: 1.5rem;
`;
